// usePageMeta.js
// -----------------------------------------------------------------------------
// Sets the browser tab title and the search-result description for a page.
// Call once at the top of each routed page component:
//
//   usePageMeta('Plan Your Visit', 'Everything you need for your first Sunday...');
//
// The title is suffixed with the church name ("Plan Your Visit | New Horizon
// Vineyard"); pass `{ exactTitle: true }` to use the title as-is (Home).
// -----------------------------------------------------------------------------

import { useEffect } from 'react';

const SITE_NAME = 'New Horizon Vineyard';

const usePageMeta = (title, description, { exactTitle = false } = {}) => {
  useEffect(() => {
    if (typeof title === 'string' && title.length > 0) {
      document.title = exactTitle ? title : `${title} | ${SITE_NAME}`;
    }

    if (typeof description === 'string' && description.length > 0) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description, exactTitle]);
};

export default usePageMeta;
